export const EXTRACT_KEYWORD_DICTS = [
    {type: 'sensitive_word', title: 'Từ khóa nhạy cảm'},
]

export const EXTRACT_CONTENT_DICTS = [
    {type: 'prefix_phone', title: 'Đầu số ĐT'},
    {type: 'first_name', title: 'Tên UV'},
    {type: 'last_name', title: 'Họ UV'},
    {type: 'school_name', title: 'Tên trường học'},
    {type: 'city', title: 'Tỉnh / Thành phố'},
    {type: 'national', title: 'Quốc tịch'},
    {type: 'country', title: 'Quốc gia'},
    {type: 'major', title: 'Chuyên ngành'},
    {type: 'role', title: 'Vai trò UV'},
    {type: 'company', title: 'Công ty'},
    // {type: 'education', title: 'Học vấn'},
    {type: 'email', title: 'Email'},
    {type: 'gender', title: 'Giới tính'},
    // IGNORE_GENDER("content/ignore_gender.lst"),
    // IGNORE_NAME("content/ignore_name.lst"),
    // MARTIAL_STATUS("content/martial_status.lst"),
    // PERSON_NAME("content/person_name.lst"),
    // STANDARD_GMAIL("content/standard_gmail.lst"),
    // STANDARD_YAHOO_MAIL("content/standard_yahoo_mail.lst"),
    // PERSONAL_EMAIL("content/personal_email.lst"),
    // STANDARD_PREFIX_PHONE("content/standard_prefix_phone.lst"),
]

export const STANDARD_DICTS = [
    {type: 'standard_gmail', title: 'Gmail'},
    {type: 'standard_yahoo_mail', title: 'Yahoo mail'},
    {type: 'personal_email', title: 'Email cá nhân'},
    {type: 'standard_prefix_phone', title: 'Chuyển đầu SĐT về 0'},
]

